module.exports = __webpack_public_path__ + "media/general_icons/check_mark_nurture_purple-bebf7f33.svg";